import { SitesService } from './../../shared/services/sites.service';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Client } from '@classes/client';
import { Site } from '@classes/site';
import { UiService } from '@services/ui.service';
import { ArticlesService } from '@services/articles.service';
import { Article } from '@classes/article';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { DatatableBaseComponent } from '@components/datatable-base.component';
import { AddressesService } from '@services/addresses.service';
import { DictionaryValue } from '@classes/dictionary/dictionaryValue';
import { DictionaryValuesService } from '@services/dictionaryValues.service';
import { Address } from '@classes/address';

@Component({
  selector: 'app-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.scss']
})
export class ArticlesComponent extends DatatableBaseComponent implements OnInit {
  clients: Client[];
  sites: Site[];
  articles: Article[];
  articlesFormated: any[];
  urgencyLevels: DictionaryValue[];
  lots: DictionaryValue[];
  senders: Address[];
  receivers: Address[];

  isLoading = false;
  isLoadingFilterForm = false;
  showSites = false;

  clientSiteForm: UntypedFormGroup;
  filterForm = new UntypedFormGroup({

    urgency: new UntypedFormControl(),
    sender: new UntypedFormControl(),
    step: new UntypedFormControl(),
  });

  filterValue = null;

  dataSource: MatTableDataSource<any>;
  data: [];
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  displayedColumns = [
    'code',
    'estimatedTime',
    'sender',
    'urgency',
    'lot',
    'step',
    'daysWeekDay',
    'daysWeekDayPackage',
    'daysWeekNight',
    'daysWeekNightPackage',
    'saturdayDay',
    'saturdayDayPackage',
    'saturdayNight',
    'saturdayNightPackage',
    'sundayDay',
    'sundayDayPackage',
    'sundayNight',
    'sundayNightPackage',
    'actions',
    'onDelete'
  ];

  headerColumns = ['codeHeader', 'estimatedTimeHeader', 'filterSender', 'filterUrgency', 'filterLot', 'filterStep', 'weekDays', 'saturday', 'sunday'];

  spans = [];

  tempRowId = null;
  tempRowCount = null;

  constructor(
    protected uiSrv: UiService,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private sitesSrv: SitesService,
    private articlesSrv: ArticlesService,
    private dictionarySrv: DictionaryValuesService,
    private addressesSrv: AddressesService,
    private _changeDectectorRef: ChangeDetectorRef
  ) {
    super(uiSrv);
  }

  public ngOnInit(): void {
    this.isLoading = true;
    this.isLoadingFilterForm = true;
    this.getRouteData();
  }

  public gAfterViewChecked(): void {
    this._changeDectectorRef.detectChanges();
  }

  private getRouteData(): void {
    this.route.data
      .subscribe((data: { clients: Client[] }) => {
        this.clients = data.clients;
        this.initForm();
        this.isLoading = false;
      });

    this.addSubscription(
      this.sitesSrv.sitesListChanged.subscribe(sitesFromSrv => {
        this.sites = sitesFromSrv;
      })
    )
  }

  initSub() {
    this.urgencyLevels = [];
    this.senders = [];
    const urgencyLevelsPromise = new Promise((resolve) => {
      this.dictionarySrv.getUrgencyList()
        .subscribe(urgencyLevelsFromSrv => {
          this.urgencyLevels = urgencyLevelsFromSrv;
          resolve(true);
        });
    });

    const addressPromise = new Promise((resolve) => {
      this.addressesSrv.getList()
        .subscribe(addressessFromSrv => {
          this.senders = addressessFromSrv.filter(address => address.isSender);
          this.receivers = addressessFromSrv.filter(address => address.isReceiver);
          resolve(true);
        });
    });

    const lotsPromise = new Promise((resolve) => {
      this.dictionarySrv.getLotsList().subscribe(lotsFromSrv => {
        this.lots = lotsFromSrv;
        resolve(true);
      })
    });

    Promise.all([urgencyLevelsPromise, addressPromise, lotsPromise])
      .then(() => {
        this.initFilterForm();
      });

    this.addSubscription(
      this.articlesSrv.articlesFormatedListChanged
        .subscribe(articles => {
          this.cacheSpan('sender', d => d.sender);
          this.cacheSpan('urgency', d => d.urgency);
          this.cacheSpan('lot', d => d.lot);
          const DATA = articles.reduce((current, next) => {
            next.stepsFormated.forEach((step, indexStep) => {
              current.push(
                {
                  id: next.id,
                  site: next.site,
                  sender: next.sender,
                  urgency: next.urgency,
                  lot: next.lot,
                  step: step,
                  stepsFormated: next.stepsFormated,
                  daysWeek: step.daysWeek,
                  saturday: step.saturday,
                  sunday: step.sunday,
                  noDays: step.noDays,
                  indexStep: indexStep,
                  code: next.code,
                  estimatedTime: next.estimatedTime
                })
            });
            return current;
          }, []);


          this.dataSource.data = DATA || [];

          this.dataSource.sort = this.sort;
          this.onEditFinished();
        })
    );
  }

  initForm() {
    this.clientSiteForm = this.fb.group({
      client: new UntypedFormControl(null, Validators.required),
      site: new UntypedFormControl(null)
    })

    this.clientSiteForm.get('client').valueChanges.subscribe(client => {
      this.showSites = false;
      this.sites = [];
      this.clientSiteForm.get('site').reset();
      if (client.id) {
        this.sitesSrv.getListByClients(client.id).subscribe(sitesFromSrv => {
          this.sites = sitesFromSrv;
          this.showSites = true;
        })
      }

    })
  }

  initFilterForm() {
    this.filterForm = this.fb.group({
      sender: new FormControl<Address>(this.filterValue?.sender ? this.filterValue.sender : null),
      urgency: new FormControl<DictionaryValue>(this.filterValue?.urgency ? this.filterValue.urgency : null),
      lot: new FormControl<DictionaryValue>(this.filterValue?.lot ? this.filterValue.lot : null),
      step: new FormControl<Address>(this.filterValue?.step ? this.filterValue.step : null)
    })

    this.isLoadingFilterForm = false;
  }

  onFilter(event): void {
    const formValue = this.filterForm.value;

    this.filterValue = formValue;
    this.filterValue.client = this.clientSiteForm.value?.client.id;
    this.filterValue.site = this.clientSiteForm.value?.site ? this.clientSiteForm.value?.site?.id : null;

    this.isLoading = true;
    this.articlesSrv.getFormated(this.filterValue, false).subscribe(articlesFromSrv => {
      this.articlesFormated = articlesFromSrv;
      this.initTable();
    })
  }

  getControl(control: string): UntypedFormControl {
    return this.clientSiteForm.get(control) as UntypedFormControl;
  }

  showArticles() {
    const formValue = this.filterForm.value;
    this.filterValue = formValue;
    this.filterValue.client = this.clientSiteForm.value.client.id;
    this.filterValue.site = this.clientSiteForm.value.site ? this.clientSiteForm.value.site.id : null;

    if (!this.filterValue.site) {
      if (!this.displayedColumns.find(col => col === 'site')) {
        this.displayedColumns.splice(2, 0, 'site')
        this.headerColumns.splice(2, 0, 'siteHeader')
      }
    } else {
      if (this.displayedColumns.find(col => col === 'site')) {
        this.displayedColumns = this.displayedColumns.filter(col => col !== 'site');
        this.headerColumns = this.headerColumns.filter(col => col !== 'siteHeader');
      }
    }

    this.isLoading = true;
    this.isLoadingFilterForm = true;
    this.articlesSrv.getFormated(this.filterValue, false).subscribe(articlesFromSrv => {
      this.articlesFormated = articlesFromSrv;
      this.initTable();
      this.initSub();
    })
  }

  showIncompleteTariffs() {
    const formValue = this.filterForm.value;
    this.filterValue = formValue;
    this.filterValue.client = this.clientSiteForm.value.client.id;
    this.filterValue.site = this.clientSiteForm.value?.site ? this.clientSiteForm.value.site.id : null;

    this.isLoading = true;
    this.isLoadingFilterForm = true;
    this.articlesSrv.getFormated(this.filterValue, true).subscribe(articlesFromSrv => {
      this.articlesFormated = articlesFromSrv;
      this.initTable();
      this.initSub();
    })
  }

  private initTable(): void {
    const DATA = this.articlesFormated.reduce((current, next) => {
      next.stepsFormated.forEach((step, indexStep) => {
        current.push({
          id: next.id,
          site: next.site,
          sender: next.sender,
          urgency: next.urgency,
          lot: next.lot,
          step: step,
          stepsFormated: next.stepsFormated,
          daysWeek: step.daysWeek,
          saturday: step.saturday,
          sunday: step.sunday,
          noDays: step.noDays,
          indexStep: indexStep,
          code: next.code,
          estimatedTime: next.estimatedTime
        })
      });
      return current;
    }, []);


    this.data = DATA;
    this.cacheSpan('sender', d => d.sender);
    this.cacheSpan('urgency', d => d.urgency);
    this.cacheSpan('lot', d => d.lot);

    this.dataSource = new MatTableDataSource(DATA);
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'urgency': {
          return item.urgency.name;
        }
        case 'lot': {
          return item.lot.name;
        }
        case 'sender': {
          if (item.sender.address) {
            return item.sender.address.name;
          } else {
            return item.sender.otherAddress;
          }
        }
        case 'steps': {
          if (item.steps[0].address) {
            return item.steps[0].address.name;
          } else {
            return item.steps[0].otherAddress;
          }
        }
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;

    if (DATA.length === 0) {
      this.filterForm.reset();
      this.filterValue = null;
    }

    this.isLoading = false;

  }

  onEditArticle(article) {
    article.isEdit = true;
    article.isEditCode = false;
    this.editedId = article.step.id;
  }

  onEditCodeArticle(article) {
    article.isEditCode = true;
    article.isEdit = false;
    this.editedId = article.step.id;
  }

  public onCancel(article: any): void {
    article.isEdit = false;
    article.isEditCode = false;
    article.isEditEstimatedTime = false;
    this.editedId = null;
  }

  onUpdate(article) {
    article.isEdit = false;
    this.editedId = null;

    let articleId = article.id;
    let stepId = article.step.id;

    let tariffs = [];

    article.daysWeek.days = [1, 2, 3, 4, 5];
    article.saturday.days = [6];
    article.sunday.days = [0];
    article.noDays.days = null;
    article.noDays.dayPrice = article.sunday.dayPrice;
    article.noDays.nightPrice = article.sunday.nightPrice;
    article.noDays.dayPackage = article.sunday.dayPackage;
    article.noDays.nightPackage = article.sunday.nightPackage;

    tariffs.push(article.daysWeek);
    tariffs.push(article.saturday);
    tariffs.push(article.sunday);
    tariffs.push(article.noDays);

    this.articlesSrv.putStepArticle(articleId, stepId, tariffs).subscribe((tariffsFromSrv) => {
      this.isLoading = false;
    });
  }

  public onCodeUpdate(article): void {
    this.articlesSrv.patchCodeArticle(article.id, article.code).subscribe((result) => {
    });
  }

  public onEditEstimatedTime(article: any): void {
    article.isEditEstimatedTime = true;
  }

  public onEstimatedTimeUpdate(article: any): void {
    if (article.estimatedTime >= 0) {
      article.isEditEstimatedTime = false;
      this.articlesSrv.patchEstimatedTime(article.id, article.estimatedTime).subscribe();
    }
  }

  public onCancelUpdateEstimatedTime(article: any): void {
    article.isEditEstimatedTime = false;
  }

  generateArticles() {
    let siteOrClient = null;
    let type = null;
    if (this.clientSiteForm.value.site && this.clientSiteForm.value.site instanceof Site) {
      siteOrClient = this.clientSiteForm.value.site;
      type = 'site';
    } else if (this.clientSiteForm.value.client && this.clientSiteForm.value.client instanceof Client) {
      siteOrClient = this.clientSiteForm.value.client;
      type = 'client';
    }

    if (siteOrClient) {
      this.isLoading = true;
      if (type === 'site') {
        this.articlesSrv.generateArticles(siteOrClient.id, null).subscribe(truc => {
          this.showArticles();
        })
      } else {
        this.articlesSrv.generateArticles(null, siteOrClient.id).subscribe(truc => {
          this.showArticles();
        })
      }
    }
  }

  cacheSpan(key, accessor) {
    for (let i = 0; i < this.data.length;) {
      let currentValue = accessor(this.data[i]);
      let count = 1;

      // Iterate through the remaining rows to see how many match
      // the current value as retrieved through the accessor.
      for (let j = i + 1; j < this.data.length; j++) {
        if (currentValue != accessor(this.data[j])) {
          break;
        }

        count++;
      }

      if (!this.spans[i]) {
        this.spans[i] = {};
      }

      // Store the number of similar values that were found (the span)
      // and skip i to the next unique row.
      this.spans[i][key] = count;
      i += count;
    }
  }

  getRowSpan(col, index) {
    return this.spans[index] && this.spans[index][col];
  }

  onDeleteArticle(idArticle: string) {
    const confirmation = confirm('Êtes-vous certain de vouloir supprimer cet article ?');

    if (confirmation) {
      this.articlesSrv.delete(idArticle).subscribe(() => {
        this.uiSrv.showSnackbar('billing.articles.list.deleted', true);
      });
    }
  }
}
